<script lang="ts" setup>
import { watch, computed, ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import config from '@/config';
import { useUserStore } from '@/stores/user';
import getCategory from '@/api/category';
import { getStaticImages, getPlaceholderFooter } from '@/utils';

const router = useRouter();
const route = useRoute();
const userStore = useUserStore();

const seoContent: any = ref({mainText: {description: ' '}, texts: (getPlaceholderFooter(config.Themename) as any).tabs});
const selectedTab = ref(seoContent?.value?.texts[0].id);

const routeName = computed(() => route.name?.toString() ?? '');

const showSeo = computed(() => {
    const seoPages = ['grid', 'adwords'];
    return userStore.safeMode ? false : seoPages.includes(routeName.value);
});

const showProfileLinks = computed(() => {
    const excludePages = ['profile', 'inbox'];
    return userStore.mobile ? !excludePages.includes(routeName.value) : true;
});

const filteredTabs = computed(() => seoContent.value?.texts?.filter(tab => tab.title) || []);

// Extract a string from route.params
const extractCategory = (category: string | string[] | undefined): string => {
    if (Array.isArray(category)) {
        return 'home';
    }
    return (typeof category === 'string' ? category.trim() : '') || 'home';
};

async function getSeoContent(category: string) {
    const { error, result } = await getCategory(category);
    if (!result || error) return;

    seoContent.value = result;
    selectedTab.value = seoContent?.value?.texts[0].id;
}

watch(() => route.params.category, (newCategory, oldCategory) => {
    if(newCategory === oldCategory) return;
    const category = extractCategory(newCategory);
    getSeoContent(category);
});

onMounted(async() => {
    await router.isReady();
    const category = extractCategory(route.params.category);
    getSeoContent(category);
});
</script>

<template src="./footer.html"></template>

<style lang="scss">
@import './footer.scss';
</style>
